import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog", "form", "input"]

  open(event) {
    const trigger = event.currentTarget
    this.formTarget.action = trigger.dataset.conversationUrl
    this.inputTarget.value = trigger.dataset.conversationTitle || ""
    this.dialogTarget.showModal()
    this.inputTarget.focus()
    this.inputTarget.select()
  }

  close() {
    this.dialogTarget.close()
  }

  closeOnBackdrop(event) {
    if (event.target === this.dialogTarget) this.close()
  }
}
